export const mapNotesLayer = {
    id: 'map notes',
    type: 'symbol',
    source: 'mapNotes',
    filter: ['all', ['match', ['geometry-type'], ['Point'], true, false], ['has', 'status']],
    layout: {
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-image': ['get', 'status'],
        'icon-offset': [0, -25],
        'icon-padding': 1,
        'icon-size': ['interpolate', ['exponential', 1.9], ['zoom'], 13.5, 0.5, 20, 1.2],
    },
    paint: {
        'icon-opacity': ['interpolate', ['exponential', 1.9], ['zoom'], 13.5, 0, 15, 1],
    },
};
